export function daysCounter(
	date: Date | undefined,
	term: "since" | "to",
): number {
	if (!date || Number.isNaN(date.getTime())) {
		return 0;
	}

	const today = new Date();
	const targetDate = new Date(date);

	targetDate.setUTCHours(0, 0, 0, 0);
	today.setUTCHours(0, 0, 0, 0);

	const diffInMs =
		term === "since"
			? today.getTime() - targetDate.getTime()
			: targetDate.getTime() - today.getTime();

	return Math.max(0, Math.floor(diffInMs / (1000 * 60 * 60 * 24)));
}
